import React from 'react';

import Icon from 'components/ui/Icon';

const CopyText = ({ publicDate }) => {
  const publicYear = publicDate.slice(0, 4);

  return (
    <p className="flex items-center oc-small text-pomegranate lg:ml-auto">
      &copy; {publicYear} fightcancer.ch, LLC. All rights reserved
      <Icon name="star" className="ml-2.5 w-4 h-4" />
    </p>
  );
};

export default CopyText;
